var map = {
	"./music-instructions.json": 3085,
	"./music-library-intro2024.json": 3086,
	"./music-library-launch2024.json": 3087,
	"./music-progression.json": 3088,
	"./startSourcesAdvanced.json": 3089,
	"./startSourcesSimple.json": 3090,
	"./startSourcesSimple2.json": 3091,
	"./startSourcesTracks.json": 3092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2864;